var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageOutlineGradient = function SvgMessageOutlineGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.303c-7.136 0-12.942 4.876-12.942 10.87 0 3.467 2.006 6.76 5.367 8.805.524.32.795.915.69 1.517a10.189 10.189 0 0 1-1.066 3.04c1.464-.31 2.749-1.066 3.898-2.288a1.491 1.491 0 0 1 1.353-.445c.884.16 1.793.24 2.7.24 7.137 0 12.943-4.876 12.943-10.87 0-5.993-5.806-10.869-12.942-10.869ZM8.146 31.155a.729.729 0 0 1-.597-1.148c.86-1.224 1.408-2.49 1.63-3.763-3.81-2.333-6.078-6.09-6.078-10.072 0-6.797 6.46-12.327 14.4-12.327 7.941 0 14.402 5.53 14.402 12.327 0 6.798-6.46 12.329-14.401 12.329-.995 0-1.99-.089-2.96-.264l-.563-.49.531.5c-1.763 1.874-3.899 2.853-6.348 2.908h-.016Z",
    fill: "url(#message-outline-gradient_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "message-outline-gradient_svg__a",
    x1: 3.1,
    y1: 3.845,
    x2: 30.372,
    y2: 32.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A93E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504CCB"
  })))));
};
export default SvgMessageOutlineGradient;